var map = {
	"./categories/en.json": [
		"65cf",
		"categories-en-json"
	],
	"./categories/fr.json": [
		"ec92",
		"categories-fr-json"
	],
	"./fr.json": [
		"9bff",
		"locales-fr-json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "a8de";
module.exports = webpackAsyncContext;